module.exports = __webpack_public_path__ + "img/tvf_logo_white_t.4ed0de89.png";